import React, { Component } from 'react';
class Footer extends Component {
  render() {
    return (
       
       <footer>

       		<div className="wrapper speciality">
       			<div className="container">
       			<h2 className="animation-box wow bounceIn animated">HAVE A COFFEE CHAT</h2>
				<div className="virticle-line"></div>
				<div className="circle"></div>
				<div className="row">
<div className="col-sm-4 col-md-4 wow animated fadeInLeft">
<a target="_blank" href="https://www.facebook.com/garymarkinfotech">
<div className="special-icon">
<i className="fa fa-facebook"></i>
        </div></a>
 				<h3>LIKE US</h3>
 				<p>
 					Like our Facebook page for more updates
 				</p>
 			</div>
 			<div className="col-sm-4 col-md-4 animation-box wow bounceIn animated">
 				<a target="_blank" href="https://www.linkedin.com/company/garymark-infotech">
        <div className="special-icon">
          <i className="fa fa-linkedin"></i>
        </div>
        </a>
 				<h3>FOLLOW US</h3>
 				<p>
 					Follow Us on  linkedin  for our latest new &amp; events
 					
 				</p>
 			</div>
 			<div className="col-sm-4 col-md-4 wow animated fadeInRight">
 				 <a target="_blank" href="https://plus.google.com/u/0/114503108909693961242/posts">
        <div className="special-icon">
          <i className="fa fa-google-plus"></i>
        </div>
        </a>
 				<h3>CONNECT US</h3>
 				<p>
 					Connect us through our  Google Plus page
 				</p>
 			</div>
 		</div>


       			</div>
       		</div>

       		<section id="footer" className="wrapper">
       			<div className="container text-center">

       			<div className="credits">

       			<ul className="breadcrumb">
                            <li><a href="index.php">HOME</a></li>
                            <li><a href="about-us.php">ABOUT US</a></li>
                             <li><a href="tripmaker.php">PRODUCT</a></li>
                            <li><a href="services.php">SERVICES</a></li>
                             <li><a href="portfolio.php">PORTFOLIO</a></li>
                            <li><a href="blog.php">BLOG</a></li>
                            <li><a href="contactus.php">CONTACT US</a></li>
                          
                        </ul>
                        Made With <i className="fa fa-heart"></i> by <a href="about-us.php">Our Team </a>
       				</div>
       				<div>©2015 - 2017 Garymark Infotech, All Rights Reserved</div>

       			</div>

       		</section>

       </footer>
    );
  }
}


export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js